import React, { Component } from 'react';

import { SecondsToMMSS } from '../../../common/constant';

export class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: props.initialTime || 0,
      stopTimerOnBtnClick: props.stopTimer || false,
      disabled: props.stopTimer || false,
    };
  }

  timerToggle = () => {
    const { stopTimerOnBtnClick } = this.state;
    clearInterval(this.timer);
    if (!stopTimerOnBtnClick) {
      this.timer = setInterval(this.tick, 1000);
    }
  };

  tick = () => {
    const timerCount = this.state.count + 1;
    this.setState({ count: timerCount }, () => {
      this.props.getTimerValue(timerCount);
    });
  };

  componentDidMount() {
    const { stopTimer, initialTime } = this.props;
    if (initialTime) {
      this.setState({ count: initialTime });
    }
    if (!stopTimer) {
      this.timer = setInterval(this.tick, 1000);
    } else {
      this.setState({ 
        stopTimerOnBtnClick: true,
        disabled: true
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  componentDidUpdate(prevProps) {
    const { stopTimer, initialTime } = this.props;
    
    // Handle initialTime changes
    if (initialTime !== prevProps.initialTime) {
      this.setState({ count: initialTime || 0 });
    }

    // Handle stopTimer changes
    if (stopTimer !== prevProps.stopTimer) {
      clearInterval(this.timer);
      if (stopTimer) {
        this.setState({ 
          stopTimerOnBtnClick: true, 
          disabled: true 
        });
      } else {
        this.setState({ 
          stopTimerOnBtnClick: false, 
          disabled: false 
        }, () => {
          this.timer = setInterval(this.tick, 1000);
        });
      }
    }
  }

  render() {
    const { count, stopTimerOnBtnClick, disabled } = this.state;
    return (
      <div>
        <div className='timer_outer'>
          <i className='fa fa-clock-o' />
          <span className='timer_box'>{SecondsToMMSS(count)}</span>
        </div>

        <button
          type='button'
          aria-label={stopTimerOnBtnClick ? 'Resume timer' : 'Pause timer'}
          className={`pause_btn ${
            stopTimerOnBtnClick ? 'icon-control-play' : 'icon-control-pause'
          }`}
          onClick={() =>
            this.setState(
              {
                stopTimerOnBtnClick: !stopTimerOnBtnClick,
              },
              () => {
                this.timerToggle();
              },
            )
          }
          disabled={disabled}
        />
      </div>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/Timer/index.jsx